
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CustomizeTooltip extends Vue {
  @Prop({ required: true }) buttonText!: string;

  @Prop({ required: true }) bodyText!: string;

  @Prop({ default: false }) arrowDown!: boolean;

  @Prop({ default: false }) arrowRight!: boolean;

  @Prop({ default: false }) arrowLeft!: boolean;
}
